import { render, staticRenderFns } from "./tiyanVip.vue?vue&type=template&id=5b7a2abe&scoped=true"
import script from "./tiyanVip.vue?vue&type=script&lang=js"
export * from "./tiyanVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a2abe",
  null
  
)

export default component.exports